import { render, staticRenderFns } from "./upload-ebook.vue?vue&type=template&id=1a4e0702&scoped=true&"
import script from "./upload-ebook.vue?vue&type=script&lang=js&"
export * from "./upload-ebook.vue?vue&type=script&lang=js&"
import style0 from "./upload-ebook.vue?vue&type=style&index=0&id=1a4e0702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e0702",
  null
  
)

export default component.exports